import dayjs from "dayjs";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDashboard } from "../../providers/dashboard";

const Detail = ({ openModal }) => {
    const { state } = useDashboard();
    const navigate = useNavigate();

    const canMakeOffer = () => {
        const history = state.selectedCarHistory?.filter(([k, _]) => k == state.selectedDetail.order_no);
        if (history[0][1].length != 1) return false;
        if (history[0][1][0].type != 'offer') return false;
        return true;
    }

    if (!state.selectedDetail) {
        return (
            <div
                className="bg-white shadow-md rounded-md p-4"
            >
                <p
                    className="text-xl font-light"
                >
                    Vælg tilbud/ordre/faktura i listen
                </p>
            </div>
        )
    };

    return (
        <div
            className="bg-white rounded-md shadow-md p-3"
        >
            <div
                className="flex py-7"
            >
                <div
                    className="flex-1"
                >
                    <p
                        className="text-xl"
                    >
                        {
                            state.selectedDetail.type
                        }
                    </p>
                    <p
                        className="font-light"
                    >
                        {
                            dayjs(state.selectedDetail.updated_at).format("DD/MM/YYYY")
                        }
                    </p>
                </div>
                <div
                    className="flex-1"
                >
                    <p
                        className="text-xl"
                    >
                        Afdeling
                    </p>
                    <p
                        className="font-light"
                    >
                        {
                            state.selectedDetail.shop.city + " " + state.selectedDetail.shop.address + " " + state.selectedDetail.shop.post_code + " " + state.selectedDetail.shop.name
                        }
                    </p>
                </div>
            </div>
            <div
                className="flex bg-skgBlue text-white -mx-3 py-2 px-3"
            >
                <div
                    className="flex-1"
                >
                    Antal
                </div>
                <div
                    className="flex-[3]"
                >
                    Tekst
                </div>
                <div
                    className="flex-1"
                >
                    A'pris
                </div>
                <div
                    className="flex-1"
                >
                    Rabat
                </div>
                <div
                    className="flex-1"
                >
                    I alt
                </div>
            </div>
            <div
                className="divide-y"
            >
                {
                    Object.entries(state.selectedDetail.lines)
                        .map(([key, val]) => {
                            return (
                                <div
                                    className="flex text-sm font-light py-1"
                                >
                                    <div
                                        className="flex-1"
                                    >
                                        {
                                            Math.floor(val.qty)
                                        }
                                    </div>
                                    <div
                                        className="flex-[3] overflow-hidden"
                                    >
                                        {
                                            val.text.text_formatted
                                        }
                                    </div>
                                    <div
                                        className="flex-1"
                                    >
                                        {
                                            val.priceIncDiscountTotal
                                        }
                                    </div>
                                    <div
                                        className="flex-1"
                                    >
                                        {
                                            val.discountPct + "%"
                                        }
                                    </div>
                                    <div
                                        className="flex-1"
                                    >
                                        {
                                            val.priceIncDiscountTotalVat
                                        }
                                    </div>
                                </div>
                            )
                        })
                }
                <div
                    className="flex pt-8 pb-6 font-light text-sm md:text-md xl:text-lg"
                >
                    <div
                        className="basis-1/2 pr-3"
                    >
                        <div
                            className="flex justify-between max-w-xs"
                        >
                            <span>
                                Brutto
                            </span>
                            <span>
                                {
                                    state.selectedDetail.priceTotal
                                }
                            </span>
                        </div>
                        <div
                            className="flex justify-between max-w-xs"
                        >
                            <span>
                                Netto
                            </span>
                            <span>
                                {
                                    state.selectedDetail.priceIncDiscountTotal
                                }
                            </span>
                        </div>
                    </div>
                    <div
                        className="basis-1/2 pl-3"
                    >
                        <div
                            className="flex justify-between"
                        >
                            <span>
                                Moms udgør 25%
                            </span>
                            <span>
                                {
                                    state.selectedDetail.vatTotal
                                }
                            </span>
                        </div>
                        <div
                            className="flex justify-between"
                        >
                            <span>
                                Rabat
                            </span>
                            <span>
                                {
                                    state.selectedDetail.discountTotal
                                }
                            </span>
                        </div>
                        <div
                            className="text-skgRed flex justify-between underline font-normal"
                        >
                            <span>
                                Total
                            </span>
                            <span>
                                {
                                    state.selectedDetail.priceIncDiscountTotalVat
                                }
                            </span>
                        </div>
                    </div>
                </div>
                {
                    canMakeOffer() && (
                        <div
                            className="bg-skgBlue -mb-3 -mx-3 rounded-b-md text-white text-center text-lg p-4 transition-all hover:bg-skgRed cursor-pointer"
                            onClick={() => navigate("/existingoffer/" + state.selectedDetail.shop.id + "/" + state.cars[state.selectedCar].plate + "/" + state.selectedDetail.order_no)}
                        >
                            Book en tid til dette tilbud
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default Detail;